<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-center">Nombre</th>
              <th scope="col" class="text-center">Descripción</th>
              <th scope="col" class="text-center">Activo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <th scope="row" class="text-center">{{ item.id }}</th>
              <td class="text-center">{{ item.name }}</td>
              <td class="text-center">{{ item.description }}</td>
              <td class="text-center">
                <div class="media-body icon-state switch-outline">
                  <label class="switch">
                    <input
                      type="checkbox"
                      @change="changeState(item.id)"
                      :checked="item.state"
                    /><span class="switch-state bg-primary"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "@/includes/connection";
import Pagination from "@/pages/components/Pagination.vue";

const list = ref([]);

const props = defineProps({
  search: {
    type: String,
    default: "",
  },
});

onMounted(() => {
  loadItems();
});

function loadItems() {
  axios
    .get("/kind-event")
    .then((response) => {
      if (response.data) {
        list.value = response.data;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}
function changeState(code) {
  axios
    .patch("/kind-event/" + code)
    .then((response) => {
      //console.log("update state", response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
}

let currentPage = ref(1);
let itemsPerPage = ref(10);

const paginatedItems = computed(() => {
  const searchLower = props.search.toLowerCase();
  const filtered = list.value.filter(
    (item) =>
      item.name.toLowerCase().includes(searchLower) ||
      item.description.toLowerCase().includes(searchLower)
  );

  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filtered.slice(start, start + itemsPerPage.value);
});

function handlePageChange(page) {
  currentPage.value = page;
}
defineExpose({ loadItems });
</script>
